import is from 'ramda/src/is';
import { camelToUnderscoreNested } from 'helpers/transformations';

const isObject = is(Object);

function routeDecorator(route) {
  const decoratedRoute = (...args) => {
    const preparedArgs = args.map((argument) => {
      if (isObject(argument)) {
        return camelToUnderscoreNested(argument);
      }

      return argument;
    });

    return route(...preparedArgs);
  };

  decoratedRoute.toString = route.toString;

  return decoratedRoute;
}

export function prepareRoutes(routes) {
  return Object.getOwnPropertyNames(routes).reduce((acc, routeName) => {
    const decoratedRoute = routeDecorator(routes[routeName]);

    acc[routeName] = decoratedRoute;

    return acc;
  }, {});
}
